<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"></div>
    
    <div class="modal-content">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Load Estimation from Draft?</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div
          class="modal-card-body">
          A draft of this estimation was automatically saved on 
          <strong>{{ formatDate(parseDate(draft.created_on)) }}</strong>. 
          Would you like to load this draft estimation? 
          If not, the draft will be over-written by the last saved estimation when
          the first change is made. 

          <div class="help is-italic">
            Note: After loading the draft, the estimation is not saved until 
            you press the save button.
          </div>
        </div>

        <footer class="modal-card-foot">
          <button
            class="button is-primary"
            @click.stop="loadEstimationFromDraft()">
            Load Draft Estimation
          </button>
          <button 
            class="button" 
            @click.stop="close()">
            Dismiss
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import { parseJSON, format } from 'date-fns'
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      parseDate: (date) => { return date ? parseJSON(date) : date },
      formatDate: (date) => { return date ? format(date, "yyyy-MM-dd HH:mm:ss") : date }
    }
  },
  computed: {
    ...mapState("cladifyEstimation", ["estimation", "draft"])
  },
  methods: {
    ...mapMutations("app", ["setNotification"]),
    loadEstimationFromDraft() {
      this.$emit('confirm', true);
      this.$emit('input', false);
    },
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
@import '@/styles/modal.scss';

.capitalize {
  text-transform: capitalize;
}
</style>
